import React from "react";
import { Routes, Route } from "react-router-dom";
import Main from "./components/Main";
import Header from "./components/Header";
import NoBarcodeComponent from "./components/neworder/NoBarcodeMain";
import MicroInHome from "./components/micro/MicroInHome";
import MicroOutHome from "./components/micro/MicroOutHome";
import ReviewBatchManager from "./components/tempbatch/ReviewBatchManager";

export default function VLPExtent() {  
  return (
    <div className="container">
      <Header />
      <Routes>
        <>
          {/* <Route path="/" element={<Main />} /> */}
          <Route path="/new-order" element={<NoBarcodeComponent />} />
          <Route path="/micro-in" element={<MicroInHome />} />
          <Route path="/micro-out" element={<MicroOutHome />} />
          <Route path="/batch-manager" element={<ReviewBatchManager />} />
          <Route path="*" element={<Main />} />
        </>
      </Routes>
    </div>
  );
}
